import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, X } from '@/components/icons';
import { authApi } from './api';
import { useAuth } from './AuthContext';

/** Persistent prompt to verify email; hidden once verified or dismissed. */
export function VerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent'>('idle');
  const [devLink, setDevLink] = useState<string | null>(null);

  if (!user || user.emailVerified || dismissed) return null;

  async function resend() {
    setStatus('sending');
    try {
      const res = await authApi.resendVerification();
      setDevLink(res.devLink ?? null);
      setStatus('sent');
    } catch {
      setStatus('idle');
    }
  }

  return (
    <div className="border-b border-brand/30 bg-brand/10">
      <div className="container-page flex flex-wrap items-center gap-x-3 gap-y-1 py-2 text-sm">
        <Mail size={16} className="text-brand-soft" />
        <span className="text-ink">Verify your email to secure your account.</span>
        {status === 'sent' ? (
          devLink ? (
            <Link
              to={devLink.replace(/^https?:\/\/[^/]+/, '')}
              className="font-semibold text-brand-soft underline"
            >
              Email isn't set up yet — verify now
            </Link>
          ) : (
            <span className="text-success">Verification email sent.</span>
          )
        ) : (
          <button
            type="button"
            onClick={resend}
            disabled={status === 'sending'}
            className="font-semibold text-brand-soft underline disabled:opacity-60"
          >
            {status === 'sending' ? 'Sending…' : 'Resend verification'}
          </button>
        )}
        <button
          type="button"
          aria-label="Dismiss"
          onClick={() => setDismissed(true)}
          className="ml-auto text-ink-faint hover:text-ink"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
